 
import { makeRequest } from '../../../../lib/api';
import {
  CreatePartnerClientRequest,
  GetPartnerClientsRequest,
  CreateClientRequest,
} from './partnerClientsApi';

// const PARTNER_CORPORATE_CLIENT_PATH = '/v1/clients/search';
const CLIENT_PATH = '/v1/clients';
const CLIENT_AFFILIATED_PATH = '/v1/clients/affiliated'; // контроллер для управления клиентами, привязанными к партнёру

export const partnerClientsController = {

  // получить клиентов партнёра
  getPartnerClientsByPartner: (data: GetPartnerClientsRequest): Promise<any> => {
    return makeRequest('get', `${ CLIENT_AFFILIATED_PATH }?partnerId=${ data.partnerId }`);
  },

  // получить авто, привязанные к партнёру через клиентов
  getVehiclesByPartner: (data: GetPartnerClientsRequest): Promise<any> => {
    return makeRequest('get', `${ CLIENT_AFFILIATED_PATH }/vehicles?partnerId=${ data.partnerId }`);
  },

  createPartnerClient: (data: CreatePartnerClientRequest): Promise<any> => {
    return makeRequest('post', `${ CLIENT_PATH }/bind_partner`, data);
  },

  deletePartnerClient: (clientId: string): Promise<any> => {
    return makeRequest('post', `${ CLIENT_PATH }/unbind_partner`, { clientId });
  },

  findClientByPhone: (phoneNumber: string): Promise<any> => {
    return makeRequest('get', `${ CLIENT_PATH }/phone/${ phoneNumber }`);
  },

  createClient: (data: CreateClientRequest): Promise<any> => {
    return makeRequest('post', `${ CLIENT_PATH }`, data);
  },

};
